import { useEffect, useState } from 'react'
// import AnimatedLetters from './AnimatedLetters'
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCss3, faHtml5, faJsSquare, faNodeJs, faReact, faGitAlt, faJava, faSass} from '@fortawesome/free-brands-svg-icons'
import Java from '../img/java.png'
import Python from '../img/python.png'
import Mongo from '../img/mongo.png'
import Express from '../img/express.png'
import mysql from '../img/mysql.svg'
import {SiMysql} from 'react-icons/si'
// import Mongodb from '@leafygreen-ui/icon';
import './About.scss'
import Loader from 'react-loaders'


function About() {
    
  return (
      <>
  <div div className='flex'>
  
      <div className="container about-page ">
        <div className="text-zone flex-1">
          <h1 className='text-[#63e8ff] font-bold text-2xl md:text-5xl'>
           More About Me
          </h1>
          <p className='sm:text-xs md:text-md'>
          I am an enthusiastic Full Stack Developer looking for a role in established IT Company with opportuninty to work with the latest technologies on Challenging and diverse projects
          </p>
          <br/>
          <p className='sm:text-xs md:text-sm'>
          I have worked on several personal projects which involves the use of Languages and frameworks like React. I have worked on various projects which deals with real world applications like amazon clone where payment gateway was also excecued using stripe, whatsapp clone and many more
          </p>
          <Link to='/portfolio' class="relative inline-flex items-center justify-center p-4 px-6 py-1 mt-3 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 border-purple-500 rounded-full shadow-md group">
         <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-purple-500 group-hover:translate-x-0 ease">
<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
         </span>
         <span class="absolute flex items-center justify-center w-full h-full text-purple-200 transition-all duration-300 transform group-hover:translate-x-full ease">My Portfolio</span>
         <span class="relative invisible">Button Text</span>
          </Link>

          
      </div>
      <div className='skills-cube top'>
          <div className='cubespinner'>
              <div className='face1'>
                  <FontAwesomeIcon icon={faReact} color='#5ccfee'/>

              </div>
              <div className='face2'>
                  <FontAwesomeIcon icon={faHtml5} color='#e56027'/>

              </div> <div className='face3'>
                  <FontAwesomeIcon icon={faNodeJs} color='#539e43'/>

              </div> <div className='face4'>
                  <FontAwesomeIcon icon={faCss3} color='#2962ff'/>

              </div> <div className='face5'>
                  <FontAwesomeIcon icon={faJsSquare} color='#ead41c'/>

              </div> 
              <div className='face6'>
              <FontAwesomeIcon  icon={faGitAlt} color='#90311f'/>
              </div>

          </div>
          

      </div>
      <div className='skills-cube bottom'>
          <div className='cubespinner'>
             
              <div className='face1'>
                  <FontAwesomeIcon icon={faSass} color='#c36291'/>

              </div>
              <div className='face2'>
                  {/* <img src={Java}  /> */}
                  <FontAwesomeIcon icon={faJava} color='#4b7897'/>
              </div>
               <div className='face3'>
              <img src={Python}  />

              </div> <div className='face4'>
              {/* <img src={mysql}  /> */}
            {/* <img src={mysql} alt="" /> */}
            <SiMysql className='text-[#005c83]'/>

              </div> <div className='face5'>
              <img src={Express}  />

              </div> 
              <div className='face6'>
              <img src={Mongo}  />
              </div>

          </div>
          

      </div>
     </div>
     </div>
     <Loader type='ball-scale-multiple'/>
     </>
   
  )
}

export default About
